import React from "react";
import { Grid } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";

const AnalyticsChart = ({ data, type }) => {
  if (!data) {
    return <div>Loading...</div>; // Or handle loading state
  }
  const totalCount =
    data?.pending +
    data?.queried +
    data?.noActionReq +
    data?.draft +
    data?.escalated;

  const calculatePercent = (value) => {
    return Math.ceil((value / totalCount) * 100);
  };
  const chartData = [
    { label: "Pending", value: calculatePercent(data?.pending || 0) },
    {
      label: type === "holiday" ? "Approved" : "Escalated",
      value: calculatePercent(data?.escalated || 0),
    },
    { label: "Queried", value: calculatePercent(data?.queried || 0) },
    {
      label: type === "holiday" ? "Reject" : "No Action Req",
      value: calculatePercent(data?.noActionReq || 0),
    },
    { label: "Draft", value: calculatePercent(data?.draft || 0) },
  ];
  const valueFormatter = (item) => `${item.value}%`;
  return (
    <>
      <Grid item xs={12}>
        <PieChart
          series={[
            {
              data: chartData,
              highlightScope: { fade: "global", highlight: "item" },
              faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
              valueFormatter,
              arcLabel: (item) => `${item.value}%`,
              arcLabelRadius: "60%",
            },
          ]}
          height={300}
        />
      </Grid>
    </>
  );
};

export default AnalyticsChart;
